import { render, staticRenderFns } from "./ApiDetailsCard.vue?vue&type=template&id=cdee1742&scoped=true&"
import script from "./ApiDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ApiDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ApiDetailsCard.vue?vue&type=style&index=0&id=cdee1742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdee1742",
  null
  
)

export default component.exports